const ES = {
    buttons: {
        accept: 'Aceptar',
        confirm: 'Confirmar',
        cancel: 'Cancelar',
        back: 'Volver',
        block: 'Bloquear',
        unblock: 'Desbloquear',
        unsubscribe: 'Dar de baja',
        save: 'Guardar',
        discard: 'Descartar cambios',
        reportPayment: 'Informar pago',
        reject: 'Rechazar',
        approve: 'Aprobar',
        login: 'Iniciar sesión',
        sendEmail: 'Enviar correo',
        close: 'Cerrar',
        preview: 'Vista previa',
        program: 'Programar',
        retry: 'Reintentar',
        modify: 'Modificar',
        submit: 'Enviar',
    },
    errors: {
        generalTitle: 'Algo no salió como esperamos',
        generalDescription: 'Lo sentimos, en este momento no fue posible completar la operación.',
        user: 'El usuario que intenta crear ya existe.',
        emailAlreadyExists: 'El correo ingresado existe para otro usuario.',
        notFound: 'Ha ocurrido un error al intentar cargar el cliente.',
        invalidPassword: 'La contraseña no debe contener datos personales.',
        downloadFile: 'Ocurrió un error al descargar el reporte. Por favor intentelo nuevamente.',
        embedLoad: 'No se pudo cargar el contenido. Intentá nuevamente.',
        loadData: 'No se pudieron cargar los datos. Intentá nuevamente.',
        pageNotFound: 'La página que buscas no existe',
        moduleLoad: 'No se pudo cargar esta sección. Intentá nuevamente.',
    },
    filter: {
        searchPlaceholder: 'Ingresá tu dato',
        search: 'Buscar',
        title: 'Filtrar',
        dateRange: 'Fecha Desde-Hasta',
        registrationDateRange: 'Fecha de Alta Desde-Hasta',
        modal: {
            title: 'Filtros de búsqueda',
            date: {
                title: 'Fecha',
                from: 'Desde fecha',
                to: 'Hasta fecha'
            },
            apply: 'Aplicar',
            delete: 'Borrar filtros'
        }
    },
    pagination: {
        of: 'de',
        empty: 'No se encontraron registros',
        warning: `No podemos cargar más páginas.<br />
        Afina tus criterios de búsqueda<br />
        para ver más resultados.`
    },
    downloadExcel: 'Descargar Excel',
    loading: 'Cargando...',
    watch: 'Ver',
    reset: 'Reset',
};

export default ES;
